























































































import { Component, Vue, Prop } from "vue-property-decorator";
import DetalheAtendimentoModel from "@/models/cadastros/saude/DetalheAtendimentoModel";
import { saudeAtendimentoService } from "@/service/cadastro/saude/atendimento/SaudeAtendimentoService";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { TransacaoModel, TransacoesModel } from "@/models/cadastros/saude/TransacoesModel";

@Component({
  components: {
    GsModalDialog,
  },
})
export default class DadosPagamento extends Vue {
  @Prop()
  readonly detalhe!: DetalheAtendimentoModel;

  transacoes: TransacoesModel = {
    tentativasDePagamentoDoValorAdicional: 0,
    transacoes: [] as TransacaoModel[]
  };
  comprovante = "";
  loading = false;

  // STATUS MODAL
  dialogType = "";
  showDialog = false;
  dialogTitle = "";
  dialogMessage = "";

  mounted() {
    this.obterPagamentos();
  }

  private obterPagamentos(): void {
    saudeAtendimentoService
      .obterPagamentos(this.detalhe.id || 0)
      .then((resp) => {
        this.transacoes = resp;
        this.transacoes.transacoes = this.transacoes.transacoes.filter(tr => tr.tipoDePagamento.name === 'VALOR_ADICIONAL_EXTRA');
        const hasTransf = this.transacoes.transacoes.filter(tr => tr.status.name !== 'AUTORIZADO' && tr.status.name !== 'CONFIRMADO').length >= 3;
        if (hasTransf) {
          this.obterComprovanteTransferencia();
        }
      });
  }

  private obterComprovanteTransferencia(): void {
    saudeAtendimentoService
      .obterNomeComprovante(this.detalhe.id || 0)
      .then((resp) => {
        this.comprovante = resp;
      });
  }

  public downloadComprovante(): void {
    this.loading = true;
    saudeAtendimentoService
      .downloadComprovante(this.comprovante)
      .then((res) => {
        const fileType = res.headers["content-type"].split(";")[0].split("/");
        let fileURL = window.URL.createObjectURL(new Blob([res.data]));
        let fileLink = document.createElement("a");
        fileLink.href = fileURL;

        fileLink.setAttribute(
          "download",
          `comprovante_${this.comprovante}.${fileType[1]}`
        );
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loading = false;
      })
      .catch((err) => {
        this.loading = false;
        this.openDialog(
          "error",
          "Erro",
          "Não há arquivo de comprovante para download."
        );
      });
  }

  private openDialog(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  public closeDialog(): void {
    this.showDialog = false;
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
        color = "error";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }

  get dialogImg() {
    return `${this.dialogType || 'info'}.png`;
  }
}
